export default __webpack_public_path__ + "static/media/section0-bg2.4c8ca705.png";